export default (userId: number | string | undefined = 0, size = 'small', clearCache?: boolean) => {
  let url = `https://d15c6wn3wbpae8.cloudfront.net/images/user/${userId}/${size}`;

  if (clearCache) {
    url += `?${Date.now()}`;
  }

  return url;
};
